import React, { useEffect } from 'react';
import c from 'classnames';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import Icon from '../Icon';
const JourneyOverlay = _ref => {
  let {
    children,
    className,
    onCloseButtonClick
  } = _ref;
  const {
    t
  } = useTranslation();
  const classNames = c('JourneyOverlay', className);
  useEffect(() => {
    const websiteMainLayout = document.querySelector('.layout-container');
    if (!websiteMainLayout) {
      return () => {};
    }
    websiteMainLayout.setAttribute('inert', 'true');
    return () => {
      websiteMainLayout.removeAttribute('inert');
    };
  }, []);
  useEffect(() => {
    document.body.classList.add('js-disable-body-scrolling');
    return () => {
      document.body.classList.remove('js-disable-body-scrolling');
    };
  }, []);
  return /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement("div", {
    className: classNames
  }, /*#__PURE__*/React.createElement("div", {
    className: "JourneyOverlay__scroll-to-top"
  }), /*#__PURE__*/React.createElement("nav", {
    className: "navbar"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "region-navigation"
  }, /*#__PURE__*/React.createElement("a", {
    href: "/",
    "aria-label": "Go to homepage",
    className: "site-logo"
  }, /*#__PURE__*/React.createElement("picture", null, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 992px)",
    srcSet: "https://www.hvcgroep.nl/themes/custom/hvcgroep_theme/logo.svg",
    width: "94px",
    height: "50px"
  }), /*#__PURE__*/React.createElement("img", {
    src: "https://www.hvcgroep.nl/themes/custom/hvcgroep_theme/logo.svg",
    alt: "HVC logo",
    role: "presentation",
    width: "82px",
    height: "30px"
  }))), /*#__PURE__*/React.createElement("nav", {
    className: "menu--secondary"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "menu"
  }, /*#__PURE__*/React.createElement("li", {
    className: "menu-item menu-item--nav-toggle"
  }, /*#__PURE__*/React.createElement("button", {
    className: "JourneyOverlay__closeOverlay",
    type: "button",
    onClick: e => {
      if (onCloseButtonClick) {
        onCloseButtonClick(e);
      }
    },
    style: {
      padding: '0',
      marginRight: '10px'
    }
  }, t('journey_overlay.close_button_text'), /*#__PURE__*/React.createElement(Icon, {
    icon: "close"
  })))))))), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "u-indent--large"
  }, children))), document.body);
};
export default JourneyOverlay;